import { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

export type StackDirection = 'vertical' | 'horizontal';
export type StackSize = 'xxxs' | 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';
export type StackAlign = 'center' | 'start' | 'end';

export interface StackProps extends HTMLAttributes<HTMLDivElement> {
    direction?: StackDirection;
    size: StackSize;
    alignItems?: StackAlign;
    children?: ReactNode;
}

const Stack = ({
    direction = 'vertical',
    size,
    alignItems,
    className,
    children,
    ...rest
}: StackProps) => (
    <div
        className={clsx(
            'stack',
            `stack-${direction}`,
            `stack-${direction}-${size}`,
            alignItems && `stack-align-${alignItems}`,
            className,
        )}
        {...rest}
    >
        {children}
    </div>
);

export default Stack;
